import Phaser, {
    Display
} from 'phaser'


//let utils;
let parent;
let location
let holder;


export default class LocationGraphics extends Phaser.Scene {
    constructor(scene = "locationGraphics") {
        super(scene);
    }
    init(data) {
        holder = data.container;
        this.holder = holder;
        location = data.location;
        this.location = location;
        parent = this.scene.get(location);
        this.parent = parent;
        this.utils = this.scene.get('utils');
    }
    preload() {
        let preload = this.scene.get('preloader');
        preload.loadIt(this.assetArray, this.ready, this);
    }

    ready() {
        let _this = arguments[0];
        _this.addGraphics(holder);
    }

    addGraphics(container) {
        parent.startToolTips();
    }



}